import { Injectable } from '@angular/core';
import { GeneralHttpService } from 'src/app/shared/general-http.service';
import { Ramo } from './ramo';

@Injectable({
  providedIn: 'root'
})
export class RamoService {
  listRamo:Ramo[];
  IdRamoByName:Ramo[];
  dateToday:any;
  private routeApi = "AdmRamoes";
  constructor(private generalHttp:GeneralHttpService) { }

  getRamo(){
    return new Promise((resolve, reject) => {
      this.generalHttp.getHttp(this.routeApi).then(r => { 
        this.listRamo = r as Ramo[];
        resolve(true);
      })
      error => reject(error);
    });
  }

  getRamoByEmpresa(idEmpresa){
    return new Promise((resolve, reject) => {
      this.generalHttp.getHttp(`${this.routeApi}/getBouquetByCompany/${idEmpresa}`).then(r => { 
        this.listRamo = r as Ramo[];
        resolve(true);
      })
      error => reject(error);
    });
  }

  updateRamo(){
    return this.generalHttp.putHttpNotValue(this.routeApi)
  }

  getRamoAplicaPac(){
    //return this.generalHttp.getHttp(this.routeApi + "/AplicaPac").then(r=> this.listRamo = r as Ramo[]);
    return new Promise((resolve, reject) => {
      this.generalHttp.getHttp(`${this.routeApi}/AplicaPac`).then(r => { 
        this.listRamo = r as Ramo[];
        resolve(true);
      })
      error => reject(error);
    });
  }

  getRamoAplicaPacPromise() {
    return this.generalHttp.getHttp(`${this.routeApi}/AplicaPac`);
  }

  getIdRamoByNombRamo(nombreRamo:string){
    this.generalHttp.getHttp(this.routeApi + "/"  + "ByNombreRamo/" + nombreRamo).then(r=> {this.IdRamoByName = r as Ramo[]});
    return this.IdRamoByName[0].codigo;
  }

  getDateToday(){   

    return this.generalHttp.getHttp(`${this.routeApi}/getDateToday`);
  }
}
